module.exports = __webpack_public_path__ + "media/images/investor-dyson-65633bbb.png";